'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _call = require('./call');

var _call2 = _interopRequireDefault(_call);

var _compose = require('./compose');

var _compose2 = _interopRequireDefault(_compose);

var _concat = require('./concat');

var _concat2 = _interopRequireDefault(_concat);

var _everyBy = require('./everyBy');

var _everyBy2 = _interopRequireDefault(_everyBy);

var _spread = require('./spread');

var _spread2 = _interopRequireDefault(_spread);

var _toBoolean = require('./toBoolean');

var _toBoolean2 = _interopRequireDefault(_toBoolean);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Determine if all arguments are truthy or if array is truthy
 *
 * @module and
 * @func
 * @since 1.0.0
 * @param {...*} args
 * @return {boolean}
 * @example
 *
 *     and(true, true); //=> true
 *     and([true, true]); //=> true
 *     and(true, true, false); //=> false
 */

var allTrue = (0, _everyBy2.default)(_toBoolean2.default);
var concatArgs = (0, _concat2.default)([]);
var alwaysArray = (0, _call2.default)(concatArgs);
var and = (0, _compose2.default)(allTrue, alwaysArray, _spread2.default);

exports.default = and;